import gql from 'graphql-tag';

export const updateCheckupAppointmentOrganization = gql`
  mutation updateCheckupAppointmentOrganization($input: UpdateCheckupInput!) {
    updateCheckupAppointmentOrganization(input: $input) {
      id
    }
  }
`;
